export default __webpack_public_path__ + "src/app/assets/images/icons/PersIcon6.svg";